"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdateDonationFailedResponse = exports.UpdateDonationFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'update-donation-failed';
const UpdateDonationFailedEvent = exports.UpdateDonationFailedEvent = Name;
const isUpdateDonationFailedResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isUpdateDonationFailedResponse = isUpdateDonationFailedResponse;
//# sourceMappingURL=index.js.map